<template>
  <div class="container">
    <i @click="change" class="el-icon-circle-close"></i>
    <div class="img_box">
      <img style="width: 100%" :src="value.content" />
    </div>
    <div class="title_box">
      <el-input
        v-model="value.anotherContent"
        placeholder="请输入二维码名称"
      ></el-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: {},
    },
  },
  name: "",

  data() {
    return {};
  },

  created() {},
  methods: {
    //#region 表单
    //#region 表单
    change() {
      this.$emit("deleteD", this.value.content);
    },
    add() {},
    edit(type, val, prop) {
      //console.log(type,val,prop);
      if (type === "delete") {
        this.$emit("upLoad", prop, true);
      } else {
        prop[type] = val;
        this.$emit("upLoad", prop, false);
        console.log("prop", prop);
      }
      //  this.$emit('change',)
    },
    dele(record) {},
    showForm(params = {}) {},
  },
};
</script >
<style lang="less" scoped>
.container {
  width: 150px;
  height: 200px;
  display: flex;
  flex-direction: column;
  position: relative;
  i {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    font-size: 1.4rem;
    display: block;
    color: #8e8e8e;
    &:hover {
      transition: all 0.2s linear;
      color: #409eff;
      cursor: pointer;
    }
  }
  .img_box {
    cursor: move;
    height: 150px;
    overflow: hidden;
  }
  .title_box {
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/addGuide/components/QCode.vue